import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PageMeta} from '../../../../../model/pagination/page-meta.model';
import {Page} from '../../../../../model/pagination/page.model';

type Action = "PAGE" | "FIRST" | "LAST" | "PREV" | "NEXT";

@Component({
    selector: "ui-paginator",
    templateUrl: "ui-paginator.component.html",
    styleUrls: ["ui-paginator.component.scss"],
    standalone: false
})
export class UiPaginatorComponent {
    @Input() pageMeta: PageMeta = new PageMeta();
    @Input()
    set page(page: Page<any>) {
        if (page) {
            this.pageMeta = page.meta;
        }
    }
    @Input() listPerPage: number[] = [15, 30, 50, 100, 200];
    @Output() update = new EventEmitter();

    get pageRange(): number[] {
        const range = new Array(this.pageMeta.pages)
            .fill(0)
            .map((_, i) => i)
            .slice(1, -1);
        return range;
    }

    showPage(page: number): boolean {
        if (this.pageMeta.pages > 7) {
            if (this.pageMeta.page < 4 && page < 5) {
                return true;
            }

            if (
                this.pageMeta.page >= this.pageMeta.pages - 4 &&
                page >= this.pageMeta.pages - 5
            ) {
                return true;
            }

            if (this.pageMeta.page >= 4 && page > this.pageMeta.page - 2) {
                return [
                    this.pageMeta.page - 1,
                    this.pageMeta.page,
                    this.pageMeta.page + 1,
                ].includes(page);
            }
        } else {
            return true;
        }

        return false;
    }

    showEllipsis(side: "left" | "right"): boolean {
        return (
            (side === "left" &&
                this.pageMeta.page >= 4 &&
                this.pageMeta.pages > 7) ||
            (side === "right" &&
                this.pageMeta.page <= this.pageMeta.pages - 5 &&
                this.pageMeta.pages > 7)
        );
    }

    setItemPerPage() {
        this.pageMeta.page = 0;
        this.update.emit();
    }

    setPage(op: Action, page?: number) {
        switch (op) {
            case "PAGE":
                if (this.pageMeta.page === page) {
                    return;
                }
                this.pageMeta.page = page;
                break;
            case "FIRST":
                if (this.pageMeta.page === 0) {
                    return;
                }
                this.pageMeta.page = 0;
                break;
            case "LAST":
                if (this.pageMeta.page + 1 === this.pageMeta.pages) {
                    return;
                }
                this.pageMeta.page = this.pageMeta.pages - 1;
                break;
            case "PREV":
                if (this.pageMeta.page === 0) {
                    return;
                }
                this.pageMeta.page--;
                break;
            case "NEXT":
                if (this.pageMeta.page + 1 === this.pageMeta.pages) {
                    return;
                }
                this.pageMeta.page++;
                break;
            default: {
                const unhandled: never = op;
                throw new Error(`Unhandled action: ${unhandled}`);
            }
        }
        this.update.emit();
    }
}
